import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/atoms/Buttons';
import { DataTable, type DataTableColumnDef } from '@/components/organisms/DataTable';

export interface BioscopeContractProps {
    bioscopes: {
        bioscopeId: number;
        cages: {
            locations: {
                name: string;
            };
            name: string;
        };
    }[];
    openMoveModal: (bioscopeId: number) => void;
}

type ContractBioscope = BioscopeContractProps['bioscopes'][number];

export function BioscopeContractListOfBioscopes({
    bioscopes,
    openMoveModal,
}: BioscopeContractProps) {
    const { t } = useTranslation();

    const columns: DataTableColumnDef<ContractBioscope>[] = [
        {
            id: 'bioscope',
            header: t('common.labels.bioscope'),
            cell: ({ row }) => (
                <Link to={`/internal/bioscopes/${row.original.bioscopeId}`}>
                    {row.original.bioscopeId}
                </Link>
            ),
        },
        {
            id: 'location',
            header: t('common.labels.location'),
            cell: ({ row }) => row.original?.cages?.locations?.name ?? '-',
        },
        {
            id: 'cage',
            header: t('common.labels.cage'),
            cell: ({ row }) => row.original?.cages?.name ?? '-',
        },
        {
            id: 'actions',
            header: t('common.labels.actions'),
            cell: ({ row }) => (
                <Button onClick={() => openMoveModal(row.original.bioscopeId)}>
                    {t('common.actions.move')}
                </Button>
            ),
        },
    ];

    return (
        <div>
            <DataTable
                data={bioscopes}
                columns={columns}
                getRowId={(bioscope) => bioscope.bioscopeId.toString()}
                enableSorting={false}
                hover={false}
            />
        </div>
    );
}
